const hasAttachments = (attachments) => {
  return {
    getDefaultAttachment() {
      const index = attachments.findIndex(attachment => attachment.isDefault);
      return index === -1 ? '' : attachments[index].attachmentNumber;
    },

    getFormattedAttachments() {
      return attachments.map((attachment) => {
        const formatted = {
          filename: attachment.filename,
          attachment,
        };
        if (attachment.isDefault) {
          formatted.isDefault = true;
        }
        return formatted;
      });
    },
    getAttachmentsWithAdded(attachment) {
      if (!attachments.length) {
        return [{ ...attachment, isDefault: true }];
      }
      return [{ ...attachment, isDefault: false }, ...attachments];
    },
    getAttachmentsWithDefault(defaultIndex) {
      return attachments.map((attachment, index) => {
        if (index === defaultIndex) {
          return { ...attachment, isDefault: true };
        }
        return { ...attachment, isDefault: false };
      });
    },
    getAttachmentsWithDeleted(index) {
      const withDeleted = [...attachments];
      withDeleted.splice(index, 1);
      return withDeleted;
    },
    getAttachmentsWithUpdated(index, attachment) {
      const withUpdated = [...attachments];
      withUpdated.splice(index, 1, attachment);
      return withUpdated;
    },
  };
};

export default hasAttachments;
